import React from 'react'

const ILCandidate = (props) => (
  <span>
    <span className="name">{props.candidate.name} </span>
    <span className="party">
      ({props.candidate.party.charAt(0)}{(props.candidate.incumbent) ? ', incumbent' : ''})
    </span>
  </span>
)

export default ILCandidate




// WEBPACK FOOTER //
// ./src/components/ILCandidate/index.js